import { getLocalStorageItem, setLocalStorageItem } from 'utils/storageUtils';

/**
 * Reading and writing a remembered view choice, without owning it.
 *
 * Not `hooks/useLocalStorageItem`, which owns a piece of state and writes it
 * back on every change: each caller here already has an owner — the open tab
 * belongs to the query string, the rule filter to the page — and a second one
 * would mean two answers to "which view is open". These read and write a key
 * through the shared helpers without holding the value.
 *
 * The try/catch is still needed on top of them. `storageUtils` guards on
 * `window.localStorage` being *present*, but a browser with storage disabled
 * throws on the property access itself, and Safari's private mode throws on
 * write — both before the helper's own guard can run. Losing a remembered
 * choice is not a reason to fail the page or the click.
 */
export const readChoice = (key: string): string | null => {
  try {
    return getLocalStorageItem(key) as string | null;
  } catch {
    return null;
  }
};

export const rememberChoice = (key: string, value: string) => {
  try {
    setLocalStorageItem(key, value);
  } catch {
    // Not remembering the choice is not a reason to fail the interaction.
  }
};
